var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 23,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m29.02 46.68c1.379-1.678 4.279-2.713 7.347-2.628 2.817 0.07899 5.358 1.091 6.612 2.628"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.56,
    cy: 31.38,
    r: 6.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.65,
    cy: 31.38,
    r: 6.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m27.53 25.77a4.619 4.619 0 0 0-4.592 4.619 4.619 4.619 0 0 0 4.619 4.619 4.619 4.619 0 0 0 4.619-4.619 4.619 4.619 0 0 0-4.619-4.619 4.619 4.619 0 0 0-0.02734 0zm-1.453 1.828a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m44.62 25.77a4.619 4.619 0 0 0-4.592 4.619 4.619 4.619 0 0 0 4.619 4.619 4.619 4.619 0 0 0 4.619-4.619 4.619 4.619 0 0 0-4.619-4.619 4.619 4.619 0 0 0-0.02734 0zm-1.453 1.828a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m41.31 18.02c1.185 2.421 3 5 9 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m30.96 18.02c-1.185 2.421-3 5-9 4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.1875c36b86bcfac8c85740ac7b414b88.svg";
export { ForwardRef as ReactComponent };